import { render, staticRenderFns } from "./AccordionDescription.vue?vue&type=template&id=10026392"
import script from "./AccordionDescription.vue?vue&type=script&lang=js"
export * from "./AccordionDescription.vue?vue&type=script&lang=js"
import style0 from "./AccordionDescription.vue?vue&type=style&index=0&id=10026392&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports